import React from "react";
import Select from "react-select";

type Option = { label: string; value: any };

type SelectProps = {
  options: Option[];
  value?: Option | Option[] | null;
  onChange?: (value: Option | Option[] | null) => void;
  placeholder?: string;
  isMulti?: boolean;
  className?: string;
  classNamePrefix?: string;
  isClearable?: boolean;
  styles?: any;
  menuPortalTarget?: HTMLElement | null;
  menuPosition?: "fixed" | "absolute";
};

const BaseSelect: React.FC<SelectProps> = ({
  options,
  value = null,
  onChange,
  placeholder = "Chọn...",
  isMulti = false,
  className,
  classNamePrefix = "react-select",
  isClearable = true,
  styles,
  menuPortalTarget,
  menuPosition,
  ...rest
}) => {
  return (
    <Select
      {...rest}
      isMulti={isMulti}
      options={options}
      value={value as any}
      onChange={(v) => onChange?.(v as any)}
      placeholder={placeholder}
      isClearable={isClearable}
      className={className}
      classNamePrefix={classNamePrefix}
      menuPortalTarget={menuPortalTarget}
      menuPosition={menuPosition}
      styles={{
        control: (base) => ({
          ...base,
          minHeight: 36,
          borderColor: "#e5e7eb",
          boxShadow: "none",
          ":hover": { borderColor: "#d1d5db" },
        }),
        valueContainer: (base) => ({
          ...base,
          padding: "2px 8px",
        }),
        indicatorsContainer: (base) => ({
          ...base,
          paddingRight: 6,
        }),
        menu: (base) => ({ ...base, zIndex: 10 }),
        menuPortal: (base) => ({ ...base, zIndex: 30 }),
        ...(styles ?? {}),
      }}
    />
  );
};

export default BaseSelect;
